import { combineEpics } from 'redux-observable'
import { signupEpic } from 'components/features/creditCard/creditCardLanding/epics/signupEpic'

export const cardLandingEpic = combineEpics(
  signupEpic,
)
